import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import WebTTMI from "./features/layout"
import Menu from "./pages/Menu"
import NotFound from "./pages/NotFound"
import { ROUTES } from "./constants"
import HomePage from "./features/homepage"
import Partner from "./features/partner"
import ThucDonTanDinh from "./features/thuc-don-tan-dinh"
import ThucDonThuDuc from "./features/thuc-don-thu-duc"
import ThienTrucBreath from "./features/thien-truc-breath"
import DiaDiem from "./features/dia-diem"
import { BookingProvider } from "./context/booking"
import PlatformRedirect from "./components/PlatformRedirect"

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <BookingProvider>
          <Routes>
            <Route
              path={ROUTES.HOME}
              element={
                <WebTTMI>
                  <HomePage />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.ABOUT}
              element={
                <WebTTMI>
                  <ThienTrucBreath />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.MENU}
              element={
                <WebTTMI>
                  <Menu />
                </WebTTMI>
              }
            />{" "}
            <Route
              path={ROUTES.THUC_DON_TAN_DINH}
              element={
                <WebTTMI>
                  <ThucDonTanDinh />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.THUC_DON_THU_DUC}
              element={
                <WebTTMI>
                  <ThucDonThuDuc />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.THUC_DON_TAN_DINH}
              element={
                <WebTTMI>
                  <ThucDonTanDinh />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.KHONG_GIAN}
              element={
                <WebTTMI>
                  <DiaDiem />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.PARTNER}
              element={
                <WebTTMI>
                  <Partner />
                </WebTTMI>
              }
            />
            <Route
              path={ROUTES.ORDER}
              element={<PlatformRedirect platform="fb" />}
            />
            <Route
              path={ROUTES.RESERVATION}
              element={<PlatformRedirect platform="tiktok" />}
            />
            <Route
              path={ROUTES.NOT_FOUND}
              element={
                <WebTTMI>
                  <NotFound />
                </WebTTMI>
              }
            />
          </Routes>
        </BookingProvider>
      </Router>
    </HelmetProvider>
  )
}

export default App
